import { MonetizationStore } from './MonetizationStore'
import pubsub from "@viewlift/pubsub"
import { getStorageItem, setStorageItem } from '../../../helpers/storageManager';

export const updateMonetizationStore = (plansData, currentSelectedPlan, firstPayment,subscriptionData) => {
    MonetizationStore.planDetails = plansData ? plansData : MonetizationStore.planDetails
    MonetizationStore.currentSelectedPlan = currentSelectedPlan ? currentSelectedPlan : MonetizationStore.currentSelectedPlan
    MonetizationStore.firstPayment = firstPayment ? firstPayment : MonetizationStore.firstPayment
    MonetizationStore.subscriptionData = subscriptionData ? subscriptionData : MonetizationStore.subscriptionData
    setStorageItem('MonetizationStore',MonetizationStore)
    pubsub.publish('monetizationStore', MonetizationStore)
} 
export const updateAuthenticationStore =async (updatedData) => {
    let subscriptionStatus = updatedData?.subscriptionInfo?.subscriptionStatus
    let isSubscribed = ((subscriptionStatus === 'COMPLETED') || (subscriptionStatus === "DEFERRED_CANCELLATION")) ? true : false
    const AuthenticationStore = getStorageItem('AuthenticationStore')
    let user = AuthenticationStore?.user
    let updatedUser = updatedData ? {...user,isSubscribed : isSubscribed ? isSubscribed : true, ...updatedData} : {...user,isSubscribed : isSubscribed ? isSubscribed : true}
    setStorageItem('AuthenticationStore',{...AuthenticationStore,user : updatedUser})
}

